import React from "react";
import type { PresenceElement } from "./types";

interface AnnotationProps {
  element: PresenceElement;
  onDismiss: (id: string) => void;
}

/**
 * Persistent note attached to a UI element.
 * Stays until the operator explicitly dismisses it.
 */
export default function Annotation({ element, onDismiss }: AnnotationProps): React.ReactElement {
  return (
    <div
      className="agent-annotation pointer-events-auto max-w-xs rounded-lg shadow-sm overflow-hidden"
      style={{
        backgroundColor: "var(--c-surface)",
        border: "1px solid var(--c-border)",
      }}
    >
      <div className="px-3 py-2">
        <p className="text-xs leading-relaxed" style={{ color: "var(--c-text-secondary)" }}>
          {element.text}
        </p>
      </div>
      <button
        onClick={() => onDismiss(element.id)}
        className="w-full px-3 py-1.5 text-[10px] font-medium text-center transition-colors"
        style={{
          color: "var(--c-text-faint)",
          borderTop: "1px solid var(--c-border)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "var(--c-hover)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "";
        }}
      >
        Dismiss
      </button>
    </div>
  );
}
